import { inject, Injectable } from '@angular/core';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiService } from './api/api.service';

@Injectable({
    providedIn: 'root',
})
export class PersonService {
    private apiService = inject(ApiService);
    private apiUrl = 'persons';

    constructor() {}

    getAllMock() {
        return of({
            data: [
                { id: 1, name: 'John Doe' },
                { id: 2, name: 'Jane Smith' },
                { id: 3, name: 'Bob Johnson' },
            ],
        });
    }

    getAll(afasCustomerId?: string | number | null) {
        return this.apiService.getCallData$<Person[]>(
            this.apiUrl,
            afasCustomerId ? { afas_customer_id: afasCustomerId } : {},
            { cache: true }
        );
    }

    get(id: number) {
        return this.apiService.getCallData$<Person>(`${this.apiUrl}/${id}`);
    }

    create(person: CreatePersonPayload) {
        return this.apiService
            .postCall$<Person>(this.apiUrl, person)
            .pipe(tap(() => this.apiService.invalidateCache(this.apiUrl)));
    }

    update(id: number, person: UpdatePersonPayload) {
        return this.apiService
            .putCall$<Person>(`${this.apiUrl}/${id}`, person)
            .pipe(tap(() => this.apiService.invalidateCache(this.apiUrl)));
    }

    delete(id: number) {
        return this.apiService
            .deleteCall$(`${this.apiUrl}/${id}`)
            .pipe(tap(() => this.apiService.invalidateCache(this.apiUrl)));
    }
}

export interface CreatePersonPayload {
    first_name: string;
    last_name: string;
    phone_number: string | null;
    email: string | null;
    afas_customer_id: string;
}

export interface UpdatePersonPayload {
    first_name: string;
    last_name: string;
    phone_number: string | null;
    email: string | null;
}

export interface Person {
    id: number;
    afas_person_id: string | number | null;
    afas_customer_id: string | number | null;
    name: string;
    street: string | null;
    house_number: string | null;
    zipcode: string | null;
    city: string | null;
    country: string | null;
    phone_number: string | null;
    email: string | null;
    kvk: string | null;
    created_at?: string;
    updated_at?: string;
}
